import Enumeration from "domain/Enumeration";

const RegistrationTypeEnum = new Enumeration({
    FACE_TO_FACE: "FACE_TO_FACE",
    NON_FACE_TO_FACE: "NON_FACE_TO_FACE"
});

export default RegistrationTypeEnum;